// Запрос на /{artId} возвращает редирект на каноничный URL карточки книги
// (вида /category/.../book-title/). В DEV сервер отдаёт JSON с полем location
// вместо реального редиректа.
export async function fetchBookPath(art: number): Promise<string> {
  const res = await fetch(`/${art}`);
  const data = import.meta.env.DEV ? await res.json() : null;
  return (data?.location || new URL(res.url).pathname).replace(/\/$/, "");
}
